import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {HistoryChangesData, HistoryDialogData} from "./types/history-changes-modal.types";
import {CommonModule, formatDate} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {historyChangesModalName} from "./configs/history-changes-config";

@Component({
  selector: 'app-history-changes-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    CommonModule,
    MatButton
  ],
  templateUrl: './history-changes-modal.component.html',
  styleUrl: './history-changes-modal.component.scss'
})
export class HistoryChangesModalComponent extends BaseModalComponent {
  private dialogData = inject<HistoryDialogData>(MAT_DIALOG_DATA);

  public sortedHistoryData: Array<HistoryChangesData> = [];

  public override ngOnInit() {
    super.ngOnInit();
    this.modalStatesService.openModal(historyChangesModalName);
    this.sortHistoryDataByTime();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(historyChangesModalName);
  }

  public russianTime(time: string): string {
    return formatDate(time, 'dd.MM.yyyy HH:mm', 'en-US');
  }

  private sortHistoryDataByTime(): void {
    this.sortedHistoryData = this.dialogData.historyChangesData.sort((a, b) => {
      return new Date(b.time).getTime() - new Date(a.time).getTime();
    });
  }
}
